import boardBox from "./boardBox.vue";
export default {
  props: { boardData: { type: Object, default: () => {} } },
  components: { boardBox },
  render(h) {
    const { boardData } = this;
    return h("div", [
      h(boardBox, {
        props: {
          width: "20%",
          title: "申请退费订单金额",
          hint: "所选时间段内申请退费工单关联订单支付总金额",
          primary: true,
          unit: "元",
          basisV: (boardData && boardData.basePayAmt) || 0,
          vipV: (boardData && boardData.vipPayAmt) || 0,
          countV: (boardData && boardData.payAmt) || 0,
        },
      }),
      h(boardBox, {
        props: {
          width: "18%",
          title: "申请退费工单数",
          hint: "所选时间段内已申请退费的工单数量",
          unit: "单",
          tagColor: "#F8CF52",
          basisV: (boardData && boardData.applyInfo.baseNum) || 0,
          vipV: (boardData && boardData.applyInfo.vipNum) || 0,
          countV: (boardData && boardData.applyInfo.num) || 0,
        },
      }),
      h(boardBox, {
        props: {
          width: "18%",
          title: "申请退费金额",
          unit: "元",
          hint: "所选时间段内已申请退费的退费总金额",
          tagColor: "#F8CF52",
          basisV: boardData ? boardData.applyInfo.basePayAmt : 0,
          vipV: boardData ? boardData.applyInfo.vipPayAmt : 0,
          countV: boardData ? boardData.applyInfo.payAmt : 0,
        },
      }),
      h(boardBox, {
        props: {
          width: "22%",
          title: "已退费工单数",
          unit: "元",
          hint: "所选时间段内已申请退费的工单中，已完成退费的工单数量",
          hint2: "已退费工单数量/申请退费工单数量",
          tagColor: "#46ADAA",
          basisV: boardData ? boardData.alreadyInfo.baseNum : 0,
          vipV: boardData ? boardData.alreadyInfo.vipNum : 0,
          countV: boardData ? boardData.alreadyInfo.num : 0,
          secondTitle: "(已退工单占比)",
          basisV2: boardData && boardData.baseNumRatio ? boardData.baseNumRatio + '%' : "0%",
          vipV2: boardData && boardData.vipNumRatio ? boardData.vipNumRatio + '%' : "0%",
          countV2: boardData && boardData.numRatio ? boardData.numRatio + '%': "0%",
        },
      }),
      h(boardBox, {
        props: {
          width: "22%",
          title: "已退费金额",
          unit: "元",
          hint: "所选时间段内已申请退费的订单中，已完成退费的退费总金额",
          hint2: "已退费金额/申请退费金额",
          tagColor: "#46ADAA",
          basisV: boardData ? boardData.alreadyInfo.basePayAmt : 0,
          vipV: boardData ? boardData.alreadyInfo.vipPayAmt : 0,
          countV: boardData ? boardData.alreadyInfo.payAmt : 0,
          secondTitle: "(已退金额占比)",
          basisV2: boardData && boardData.baseAmtRatio ? boardData.baseAmtRatio + '%' : "0%",
          vipV2: (boardData && boardData.vipAmtRatio) ? boardData.vipAmtRatio + '%' : "0%",
          countV2: (boardData && boardData.amtRatio) ? boardData.amtRatio + '%' : "0%",
        },
      }),
    ]);
  },
};
